module.exports = __webpack_public_path__ + "media/images/search/cluster_red-5bd9f4da6639226b7f34ef0fc5f5b0be.svg";